module.exports = __webpack_public_path__ + "img/time Oo samples-28(1).2aa22b46.svg";